import { Link } from '@checkatrade/web-ui';
import { CreditCard } from '@cat-home-experts/mortar-iconography-web/CreditCard';
import { track } from 'lib/sdks/analytics';
import {
  type MouseEvent as ReactMouseEvent,
  useEffect,
  useId,
  useRef,
  useState,
} from 'react';
import { default700 } from 'lib/mortar';

export function PaymentBadgeV2({
  payment,
  location,
}: {
  payment?: { status?: string };
  location: string;
}) {
  const id = useId();
  const isOverRef = useRef<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const [show, setShow] = useState(false);

  function close(event: any) {
    if (buttonRef.current?.contains(event.target as Node)) return;
    if (tooltipRef.current?.contains(event.target as Node)) return;
    setShow(false);
  }

  useEffect(() => {
    if (!show) return;
    document.addEventListener('click', close);

    return () => document.removeEventListener('click', close);
  }, [show]);

  if (payment?.status !== 'READY_FOR_PAYMENT') {
    return null;
  }

  function stopPropagation(event: ReactMouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }

  const hideTooltip = () => {
    isOverRef.current = false;
    setTimeout(() => {
      if (isOverRef.current === false) {
        setShow(false);
      }
    }, 500);
  };

  const showTooltip = () => {
    isOverRef.current = true;
    setShow(true);
  };

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onMouseEnter={() => showTooltip()}
        onMouseLeave={() => hideTooltip()}
        onClick={() => showTooltip()}
        className="-ml-1 mt-px flex items-center gap-1 rounded text-sm text-neutral-strong"
        aria-expanded={show}
        aria-controls={id}
      >
        <CreditCard color={default700} size={16} />
        Accepts Checkatrade Pay
      </button>
      <div
        onClick={stopPropagation}
        onMouseEnter={() => showTooltip()}
        onMouseLeave={() => hideTooltip()}
        ref={tooltipRef}
        id={id}
        className={`absolute top-9 z-10 ${show ? 'block' : 'hidden'} w-60 rounded-lg bg-default-900 p-3 text-sm text-white before:absolute before:inset-x-0 before:-top-1 before:-z-10 before:mx-auto before:size-4 before:rotate-45 before:bg-default-900 peer-aria-[expanded=true]:block`}
      >
        <span className="inline">
          Ask your tradesperson for a payment link. We guarantee the work for up
          to £1,000 for 12 months.{' '}
          <Link
            as="a"
            href="https://www.checkatrade.com/guarantee-terms"
            className="font-semibold text-white underline"
            target="_blank"
            onClick={() => {
              track('global.payments_find_out_more', { location });
            }}
          >
            T&Cs apply
          </Link>
        </span>
      </div>
    </div>
  );
}
